<template>
  <div class="min-h-screen bg-gray-50 flex items-center justify-center p-12">
    <div class="bg-white rounded-2xl shadow-xl max-w-2xl w-full p-8 md:p-12">
      <!-- Icône -->
      <div class="flex justify-center mb-6">
        <div class="w-28 h-28 bg-green-500 rounded-full flex items-center justify-center">
          <svg class="w-14 h-14 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>
      </div>

      <!-- Titre -->
      <h1 class="text-center text-[#04406E] text-2xl md:text-3xl font-bold uppercase mb-4">
        SIGNALEMENT CRÉÉ AVEC SUCCÈS
      </h1>

      <!-- Description -->
      <p class="text-center text-gray-700 text-sm md:text-base mb-8 leading-relaxed">
        Votre signalement a été transmis à la Cour des Comptes avec succès. 
        Conservez précieusement votre code de suivi pour consulter l'état de votre signalement.
      </p>

      <!-- Code de suivi -->
      <div v-if="codeSuivi" class="mb-8">
        <label class="block text-gray-900 font-semibold text-sm mb-3">
          Code de Suivi Confidentiel
        </label>
        <div class="bg-gray-50 border-2 border-gray-300 rounded-lg p-4">
          <p class="text-center text-2xl md:text-3xl font-mono font-bold text-[#04406E] break-all uppercase">
            {{ codeSuivi }}
          </p>
        </div>
        <p class="text-center text-gray-600 text-xs mt-3">
          Conservez ce code pour suivre l'avancement de votre signalement
        </p>
      </div>

      <!-- ID Signalement (optionnel, affiché discrètement) -->
      <div v-if="idSignalement" class="mb-6 text-center">
        <p class="text-xs text-gray-500">
          ID Signalement: <span class="font-mono">{{ idSignalement }}</span>
        </p>
      </div>

      <!-- Bouton pour suivre le signalement -->
      <button
        v-if="codeSuivi"
        @click="goToSuivre"
        class="w-full bg-[#04406E] hover:bg-[#033a5a] text-white font-semibold py-4 rounded-lg transition-all duration-200 shadow-md hover:shadow-lg text-sm md:text-base mb-4"
      >
        Suivre mon Signalement
      </button>

      <!-- Bouton retour accueil -->
      <button
        @click="goHome"
        class="w-full bg-gray-200 hover:bg-gray-300 text-gray-800 font-semibold py-4 rounded-lg transition-all duration-200 text-sm md:text-base"
      >
        Retour à l'accueil
      </button>

      <!-- Note d'information -->
      <div class="mt-8 bg-blue-50 border-2 border-blue-200 rounded-xl p-5">
        <p class="text-gray-800 text-sm leading-relaxed">
          <span class="font-semibold">Important:</span> 
          Votre code de suivi est confidentiel. Ne le partagez qu'avec les personnes autorisées. 
          Si vous avez perdu votre code et n'êtes pas anonyme, contactez-nous à l'adresse: 
          <a href="mailto:signalement@courdescomptes.bj" class="text-blue-600 hover:text-blue-800 underline">
            signalement@courdescomptes.bj
          </a>
        </p>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';

const route = useRoute();
const router = useRouter();
const codeSuivi = ref<string>('');
const idSignalement = ref<string>('');

// Fonction pour mettre à jour les valeurs depuis les query params
const updateFromQuery = () => {
  const code = route.query.code as string;
  const id = route.query.id as string;
  
  console.log('🔍 [Confirmation] Query params:', { code, id, allQuery: route.query });
  
  if (code) {
    codeSuivi.value = code;
    console.log('✅ [Confirmation] Code de suivi récupéré:', code);
  }
  
  if (id) {
    idSignalement.value = id;
    console.log('✅ [Confirmation] ID signalement récupéré:', id);
  }
  
  // Si pas de code, rediriger vers l'accueil après 3 secondes
  if (!code) {
    console.warn('⚠️ [Confirmation] Pas de code de suivi dans les query params. Redirection vers l\'accueil dans 3 secondes...');
    setTimeout(() => {
      router.push({ name: 'home' });
    }, 3000);
  }
};

// Mettre à jour au montage
onMounted(() => {
  updateFromQuery();
});

// Surveiller les changements de query params (au cas où ils changeraient)
watch(() => route.query, () => {
  updateFromQuery();
}, { immediate: true });

const goHome = () => {
  router.push({ name: 'home' });
};

const goToSuivre = () => {
  if (codeSuivi.value) {
    router.push({
      name: 'suivre-un-signalement'
    });
  }
};
</script>

<style scoped>
/* Styles additionnels si nécessaire */
</style>
